<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import './less/reset.css'
export default {
  name: 'App'
}
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  font-family: '微软雅黑', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  overflow-x: hidden;
  background-color: #f5f5f5;
}
#app::-webkit-scrollbar {/*滚动条整体样式*/
  width: 0px;     /*高宽分别对应横竖滚动条的尺寸*/
  background-color: white;
}
#app::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
  height: 5px;
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
  background-color: #406ef3;
  transition: background-color .3s;
}
#app::-webkit-scrollbar-track {/*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0);
  border-radius: 0;
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/App.vue